import { cn } from "@/lib/utils";

/**
 * Etiqueta de estado.
 *
 * `tone` é semântico, não decorativo — a mesma regra de cor do sistema:
 * emerald = dinheiro/sucesso, teal = progressão, brand = ação/informação,
 * amber = atenção, red = falha, slate = neutro/inativo.
 */
const TONE = {
  neutral: "bg-slate-100 text-slate-600",
  info: "bg-brand-50 text-brand-700",
  progress: "bg-teal-50 text-teal-700",
  success: "bg-emerald-50 text-emerald-700",
  warning: "bg-amber-50 text-amber-700",
  danger: "bg-red-50 text-red-600",
  purple: "bg-violet-50 text-violet-700",
};

export default function Badge({ tone = "neutral", dot = false, className, children }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap",
        TONE[tone] || TONE.neutral,
        className,
      )}
    >
      {dot && <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70 shrink-0" aria-hidden />}
      {children}
    </span>
  );
}
